import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  currentResidentialAddress: () =>
    i18n.t(i18nKeys.residential__address__current),
  previousResidentialAddress: () =>
    i18n.t(i18nKeys.residential__address__previous),
  country: () => i18n.t(i18nKeys.residential__address__country),
  address: () => i18n.t(i18nKeys.residential__address__address),
  streetAddress: () => i18n.t(i18nKeys.residential__address__streetAddress),
  city: () => i18n.t(i18nKeys.residential__address__city),
  state: () => i18n.t(i18nKeys.residential__address__state),
  zipCode: () => i18n.t(i18nKeys.residential__address__zipCode),
  durationAtAddressText: () =>
    i18n.t(i18nKeys.residential__address__durationAtAddress),
  dontIncludeThisMonthText: () =>
    i18n.t(i18nKeys.residential__address__dontIncludeThisMonth),
  years: () => i18n.t(i18nKeys.residential__address__years),
  months: () => i18n.t(i18nKeys.residential__address__months),
  removeAddress: () => i18n.t(i18nKeys.residential__address__removeAddress),
  required: () => i18n.t(i18nKeys.residential__address__required),
  postCode: () => i18n.t(i18nKeys.residential__address__postCode),
}
